import React from "react";
import { motion } from "framer-motion";
import "../../roadmap.css";

const phases = [
  {
    title: "Core Platform",
    desc: "Frontend, backend, real-time tracking",
    progress: 70,
  },
  {
    title: "Community",
    desc: "Social media content production",
    progress: 0,
  },
  {
    title: "Smart Contracts",
    desc: "Testing, optimization, efficiency",
    progress: 80,
  },
  {
    title: "Fusion Swap",
    desc: "For more efficient trading 1Inch Fusion Swap will be added",
    progress: 5,
  },
  {
    title: "Gamble",
    desc: "Unique tournament smart contracts creation",
    progress: 90,
  },
  {
    title: "Audit & Validation",
    desc: "Audit, fixes, security verification",
    progress: 80,
  },
  {
    title: "Redistributor Model",
    desc: "Multi-block logic, tokenomics stabilization",
    progress: 100,
  },
  {
    title: "The Entire Project Readiness",
    desc: "Redistributor Token with its ecosystem.",
    progress: 65,
  },
];
export default function RoadmapTimeline() {
  return (
    <div className="pageContent">
      <div className="aboutBlock">
        <h3>ROADMAP</h3>
        <div className="roadmap-container">
          <div className="roadmap-wrapper">
            {phases.map((phase, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="roadmap-item"
              >
                <div className="roadmap-dot">
                  <div
                    className="roadmap-dot-progress"
                    style={{ height: `${phase.progress}%` }}
                  />
                </div>
                <div className="roadmap-content">
                  <div className="roadmap-text">
                    <h3>{phase.title}</h3>
                    <p>{phase.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
